import { type Review } from 'schema-dts'

import { type ProductReviewServiceReducedReviewV1 } from '@redteclab/api/clients/bully'

import { getRatingSchema } from './getRatingSchema'
import { type PartiallyRequired } from './jsonLdSchema.types'

/**
 * Undefined values cut during serialization, but Google requires them,
 * so we fill keys with empty strings
 */
type GoogleReview = PartiallyRequired<
  Review,
  'author' | 'name' | 'reviewBody' | 'reviewRating'
>

export const getReviewSchema = (
  review: ProductReviewServiceReducedReviewV1,
): GoogleReview => ({
  '@type': 'Review',
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- need contract update author could be undefined
  author: review.customer.author ?? '',
  datePublished: review.submissionDate,
  name: review.title,
  reviewBody: review.message,
  reviewRating: getRatingSchema(review.rating),
})
